<svg viewBox="0 0 1000 1000">
  <path *ngFor="let sliceClass of sliceClasses; let index=index" [ngClass]="sliceClass" attr.d="M{{getLeftPoint()}}
                          L500 500
                          L{{getRightPoint()}}
                          A500 500 0 0 0 {{getLeftPoint()}}
                          Z" [attr.transform]="'rotate(' + 45 * index + ' 500 500)'"
  />
</svg>
